import React, { useRef, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { toast } from 'react-toastify';
import axios from 'axios';
import Portal from "./portal";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={"/images/menu-dots.svg"} alt="menu" />
    </a>
));

export default function MenuDropdown({ clickfunction, reloadfunction, id, video_url, category_id }) {
    const deleteHandle = (id) => {
        const url = `${process.env.REACT_APP_API_URL}/video-finder?ids=${JSON.stringify([id])}`;
        axios.delete(url).then(response => {

            reloadfunction();
            toast.error('Deleted successfully')
        }).catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    const downloadHandler = (video_url, category_id) => {
        const url = `${process.env.REACT_APP_API_URL}/video-finder-transcript-summary?video_url=${video_url}&category_id=${category_id}`;
        const toastId = toast.loading('Downloading...');

        axios.get(url)
            .then(response => {
                const fileName = response.data.data;

                return fetch(fileName)
                    .then(res => {
                        if (!res.ok) throw new Error('File download failed');
                        return res.blob();
                    })
                    .then(blob => {
                        const blobUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = blobUrl;

                        // Extract filename from path
                        const match = fileName.match(/\/([a-zA-Z0-9_-]+)\.mp4$/);
                        const id = match ? match[1] : 'video';
                        link.download = `${id}.mp4`;

                        document.body.appendChild(link);
                        link.click();

                        // Cleanup
                        link.remove();
                        window.URL.revokeObjectURL(blobUrl);
                    });
            })
            .then(() => {
                toast.dismiss(toastId);
                toast.success('Downloaded successfully!');
            })
            .catch(error => {
                toast.dismiss(toastId);
                console.error('Download failed:', error);
                toast.error('Download failed!');
            });
    };

    const toggleRef = useRef(null);
    const [show, setShow] = useState(false);

    return (
        <Dropdown show={show} onToggle={() => setShow(!show)}>
            <Dropdown.Toggle as={CustomToggle} ref={toggleRef} />
            <Portal show={show} targetRef={toggleRef}>
                <Dropdown.Menu size="sm" title="">
                    <Dropdown.Item className="d-flex align-items-center justify-content-end" style={{ width: '50px', float: 'right' }}>
                        <img src={"/images/close.svg"} alt="close" />
                    </Dropdown.Item>
                    <Dropdown.Item className="d-flex align-items-center gap-2" onClick={() => clickfunction(id)}>
                        <img src={"/images/info.svg"} alt="info" />
                        <p className="mb-0">More info</p>
                    </Dropdown.Item>
                    <Dropdown.Item className="d-flex align-items-center gap-2" onClick={() => deleteHandle(id)}>
                        <img src={"/images/delete.svg"} alt="trash" />
                        <p className="mb-0"> Delete</p>
                    </Dropdown.Item>
                    <Dropdown.Item className="d-flex align-items-center gap-2" onClick={() => downloadHandler(video_url, category_id)}>
                        <img src={"/images/download-square.svg"} height={18} />
                        <p className="mb-0"> Download</p>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Portal>
        </Dropdown>
    );
}